var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-dialog",
          {
            attrs: {
              title: "Address",
              visible: _vm.dialogVisible,
              "show-close": false,
              "destroy-on-close": "",
              top: "1vh",
              width: "624px"
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogVisible = $event
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "address-content" },
              _vm._l(_vm.addressList, function(e, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "address-content-list",
                    class: [e.select ? "address-border" : ""],
                    on: {
                      click: function($event) {
                        return _vm.selectAddress(e, i)
                      }
                    }
                  },
                  [
                    _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(e.name) +
                          "  " +
                          _vm._s(e.lastname)
                      ),
                      _c("br"),
                      _vm._v("\n            " + _vm._s(e.address) + " "),
                      _c("br"),
                      _vm._v(
                        "\n            " +
                          _vm._s(e.city) +
                          ", " +
                          _vm._s(e.province) +
                          ", " +
                          _vm._s(e.countryName) +
                          "  " +
                          _vm._s(e.postCode) +
                          " "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n             " +
                          _vm._s(e.areaCode) +
                          "-" +
                          _vm._s(e.phone) +
                          "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-close address-close",
                      on: {
                        click: function($event) {
                          return _vm.deleteAddress(e)
                        }
                      }
                    })
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            this.addressList.length < 5
              ? _c("div", { staticClass: "address-add" }, [
                  _c("div", { on: { click: _vm.openAddress } }, [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Add   Address")])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "address-footer" }, [
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "address-footer-button btn-black",
                      attrs: { type: "primary" },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("Submit")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "address-footer-button",
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("address-inner", {
          ref: "addressInner",
          attrs: {
            getAddressList: _vm.getAddressList,
            addressMessage: _vm.addressMessage
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00a73dff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a73dff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/address.vue
// module id = HG0t
// module chunks = 2